import { ClosureDTO, ClosureFileDTO, IJobSearchFilterDTO } from 'wisestep-api';

export const closurePayload: ClosureDTO = {
  id: '',
  ourEntityId: '',
  ourEntityName: '',
  clientName: '',
  clientId: '',
  candidateId: '',
  candidateName: '',
  candidateLocation: null,
  candidateEmail: '',
  candidateContact: '',
  candidatePhone: '',
  positionId: '',
  offerDate: null,
  joiningDate: null,
  currencyId: '',
  compensationAmount: 0,
  period: '',
  feeArrangementId: '',
  feeArrangementAmount: 0,
  commissionValue: 0,
  employmentGuaranteeDays: 0,
  employmentGuaranteeEndDate: null,
  accountManager: '',
  clientRecruiterOne: '',
  clientRecruiterTwo: '',
  comments: '',
  workspaceId: '',
  positionTitle: '',
  clientRecruiterIdOne: '',
  placementOrigin: '',
  wisestepCandidate: false,
  arrangementType: 'SELECTED',
  feeType: 'FIXED',
  team: '',
  description: '',
};

export const closureFilePayload: ClosureFileDTO = {
  id: '',
  closureId: '',
  file: { name: '', location: '' },
  createdByName: '',
  createdBy: '',
  modifiedBy: '',
  createdOn: null,
  modifiedOn: null,
  documentName: '',
  documentType: '',
  validFrom: null,
  validTo: null,
};

export interface IInvoiceList {
  id?: string;
}

export interface IClosureDocumentsProps {
  closureId: string;
  showEditClosure: boolean | string;
}

export const jobSearchPayload: IJobSearchFilterDTO = {
  clientName: '',
  page: 0,
  size: 100,
  sort: [],
};
